import api from "@/helpers/api";
import type { Config } from "../types/config";

export const getWidgetConfig = async () => {
  const response = await api.get({ path: "/settings" });
  return response;
};

export const saveWidgetConfig = async (config: Config) => {
  const response = await api.post({ path: "/settings", data: config });
  return response;
};
